// Tower colour language — ONE place. Every fill in the river, the instruments and
// the console reads from these CSS custom properties. They resolve to the app's
// white-label tokens where one exists (`--primary`, `--border`, `--muted-foreground`)
// and to `--status-*` custom properties for the semantic tones; the fallback hexes
// only apply until `--status-ok/warn/danger/info` land in index.css + the preset
// (phase 0 quick win) — so switching the tenant theme re-colours the Tower for free.

export const TONE = {
  ink: 'hsl(var(--primary))',
  inkSoft: 'hsl(var(--primary) / 0.28)',
  line: 'hsl(var(--border))',
  muted: 'hsl(var(--muted-foreground))',
  text: 'hsl(var(--foreground))',
  surface: 'hsl(var(--background))',
  ok: 'var(--status-ok, #1F8A5B)',
  okSoft: 'var(--status-ok-soft, #DFF3E8)',
  /** DONE / irreversible in the river (ticketed · confirmed · accepted · issued):
   *  the semantic green, not the brand blue — blue (hatched) stays "reversible /
   *  in progress", green reads "committed, good" at a glance. */
  done: 'var(--status-ok, #1F8A5B)',
  doneSoft: 'var(--status-ok-soft, #DFF3E8)',
  warn: 'var(--status-warn, #C27C08)',
  warnSoft: 'var(--status-warn-soft, #FBEFD3)',
  danger: 'var(--status-danger, #CC3E37)',
  dangerSoft: 'var(--status-danger-soft, #FBE1DF)',
  info: 'var(--status-info, #2769C9)',
  infoSoft: 'var(--status-info-soft, #DDE8FA)',
  pend: 'var(--status-pending, #E8C98A)',
  pendSoft: 'var(--status-pending-soft, #F5E6C4)',
} as const;
